export default __webpack_public_path__ + "static/media/avatar_siti8.b65742bd.mp3";